import type { ReactNode } from "react";

export default function PageHeader({ title, subtitle, action }: { title: string; subtitle?: string; action?: ReactNode }) {
    return (
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between sm:gap-6">
            <div className="min-w-0 flex-1">
                <h1 className="font-display text-2xl font-bold leading-tight tracking-tight text-foreground break-words sm:text-3xl">{title}</h1>
                {subtitle ? <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-[0.95rem]">{subtitle}</p> : null}
            </div>
            {action ? (
                <div className="flex w-full shrink-0 sm:w-auto sm:justify-end">
                    <div className="w-full min-w-0 sm:w-auto sm:[&_button]:w-auto [&_button]:w-full">{action}</div>
                </div>
            ) : null}
        </div>
    );
}
